import * as actionTypes from '../actionTypes/Chat'
import { updateObject } from '../utility'

export const initialState = {
    messages: [],
    isMessagesTabOpen: true,
}

const addMessage = (state, action) => {
    const newMessages = [...state.messages, action.message]
    return updateObject(state, {
        messages: newMessages,
    })
}

const setMessagesTabOpen = (state, action) => {
    return updateObject(state, {
        isMessagesTabOpen: action.isOpen,
    })
}

const Chat = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADD_MESSAGE:
            return addMessage(state, action)
        case actionTypes.SET_MESSAGES_TAB_OPEN:
            return setMessagesTabOpen(state, action)
        default:
            return state
    }
}

export default Chat
